import { render, staticRenderFns } from "./ContractReminder.vue?vue&type=template&id=efce06e2&"
import script from "./ContractReminder.vue?vue&type=script&lang=ts&"
export * from "./ContractReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efce06e2')) {
      api.createRecord('efce06e2', component.options)
    } else {
      api.reload('efce06e2', component.options)
    }
    module.hot.accept("./ContractReminder.vue?vue&type=template&id=efce06e2&", function () {
      api.rerender('efce06e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/ContractReminder.vue"
export default component.exports